import { FilterWrapper } from 'components/filter-wrapper';
import { Flex, RadioBox, RadioBoxLabel, Text } from 'components/ui';
import { BookingConfig, ProductEnum, ProductTypes } from 'lib/api/generated';
import React, {
  ChangeEvent,
  FC,
  SetStateAction,
  useEffect,
  useMemo,
} from 'react';
import { useMedia } from 'react-use';
import { breakpoints } from 'styles/breakpoints';
import { globalTheme } from '../../styles/global-theme';

interface IStockRequiredSummaryHeader {
  config: BookingConfig;
  category?: string[];
  setCategory: React.Dispatch<SetStateAction<string[] | undefined>>;
  setProductType: React.Dispatch<SetStateAction<{ type: string } | undefined>>;
  productType: string | undefined;
}

export const StockRequiredSummaryHeader: FC<IStockRequiredSummaryHeader> = ({
  config,
  category,
  setCategory,
  setProductType,
  productType,
}) => {
  const isMobile = useMedia(`(max-width: ${breakpoints.medium})`);

  return (
    <FilterWrapper>
      <Flex
        gap={1}
        wrap='wrap'
        direction='column'
        alignItems={isMobile ? 'center' : ''}
      >
        <Flex
          gap={1}
          alignItems='center'
          direction={isMobile ? 'column' : 'row'}
          maxWidth={'max-content'}
        >
          <Text fontSize={3} fontWeight='medium' maxWidth={'max-content'}>
            Product type
          </Text>
          {config?.products.map((stockType: any, idx: any) => {
            const defaultValue = config?.products.find(
              (product) => product.product_id === productType
            );

            return (
              <RadioBox
                key={idx}
                onChange={() => {
                  setProductType({ type: stockType['product_id'] });
                  setCategory(undefined);
                }}
                value={stockType['product_id']}
                label={stockType['name']}
                defaultChecked={
                  stockType.product_id === defaultValue?.product_id
                }
                checked={stockType.product_id === defaultValue?.product_id}
                defaultValue={defaultValue?.product_id}
                name={`radio_select-type`}
                height={globalTheme.space[3]}
                type='radio'
              />
            );
          })}
        </Flex>
        <Flex
          gap={1}
          alignItems='center'
          direction={isMobile ? 'column' : 'row'}
          maxWidth={'max-content'}
        >
          <Text
            fontWeight='medium'
            fontSize={isMobile ? 'bookingMobile' : 3}
            maxWidth={'max-content'}
          >
            {config?.categories?.[productType as string]?.name}
          </Text>
          <Flex gap={1} wrap='wrap' justifyContent='center'>
            {config?.categories?.[productType as string]?.values.map(
              (el, idx) => (
                <RadioBox
                  key={idx}
                  value={el['key']}
                  label={el['name']}
                  type='checkbox'
                  name={`radio_select-main-cat`}
                  height={globalTheme.space[3]}
                  checked={category?.includes(el.key)}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    const isChecked = event.target.checked;
                    setCategory((prev) => {
                      const current = prev || [];
                      if (isChecked) {
                        return [...current, el.key];
                      } else {
                        return current.filter((key) => key !== el.key);
                      }
                    });
                  }}
                  bookingCell={isMobile}
                />
              )
            )}
          </Flex>
        </Flex>
      </Flex>
    </FilterWrapper>
  );
};
